/** Lands a completed company switch on a fresh document rather than the running SPA. */
export const reloadIntoNewContext = (target: string): void => {
  // Clearing the query cache in place cannot work here: the previous context's pages are still
  // mounted, and a cleared query has no `dataUpdatedAt`, so it refetches on its next render —
  // against the new context, which is not authorized for it (DL-67243). A new document has no
  // observers left to refetch. Must stay synchronous: awaiting anything first lets the org
  // transition effect in AuthProviderFederated fire its own clear() before we navigate away.
  window.location.replace(target);
};
